// Oconala Home — guarded against double-init since the loader snippet is included in every section
if (!window.__oconalaHomeInit) {
window.__oconalaHomeInit = true;
(function(){
  var quoteEl = document.getElementById('htQuote');
  var nameEl = document.getElementById('htName');
  var avatarEl = document.getElementById('htAvatar');
  var dotsEl = document.getElementById('htDots');
  if(!quoteEl) return;

  var testimonials = [
    { quote: '"I can tell a difference in my performance and recovery within days."', name: 'Michelle L.', avatar: 'https://placehold.co/108x108/FDE8E2/E8385C?text=%F0%9F%93%B7' },
    { quote: '"It works great — I\'m not as sore in the morning anymore."', name: 'Amanda W.', avatar: 'https://placehold.co/108x108/F2ECE2/161616?text=%F0%9F%93%B7' },
    { quote: '"Easy to digest and genuinely good for my gut health."', name: 'Emily H.', avatar: 'https://placehold.co/108x108/FDE8E2/E8385C?text=%F0%9F%93%B7' },
    { quote: '"Three weeks in and I\'m recovering faster than ever."', name: 'Megan P.', avatar: 'https://placehold.co/108x108/F2ECE2/161616?text=%F0%9F%93%B7' },
    { quote: '"My energy is finally consistent — no more 3pm crash."', name: 'Rachel T.', avatar: 'https://placehold.co/108x108/FDE8E2/E8385C?text=%F0%9F%93%B7' }
  ];

  // If the section passed real block data via data-testimonials, use that instead.
  if (dotsEl && dotsEl.dataset && dotsEl.dataset.testimonials) {
    try {
      var parsed = JSON.parse(dotsEl.dataset.testimonials);
      if (Array.isArray(parsed) && parsed.length) { testimonials = parsed; }
    } catch (e) { /* fall back to defaults above */ }
  }


  var current = 0, timer;

  testimonials.forEach(function(t, i){
    var dot = document.createElement('button');
    if(i === 0) dot.className = 'active';
    dot.setAttribute('aria-label', 'Show testimonial ' + (i+1));
    dot.addEventListener('click', function(){ show(i); resetTimer(); });
    dotsEl.appendChild(dot);
  });

  function show(i){
    current = i;
    quoteEl.classList.add('fading');
    setTimeout(function(){
      quoteEl.textContent = testimonials[current].quote;
      nameEl.innerHTML = '<span class="check">✓</span>' + testimonials[current].name;
      avatarEl.src = testimonials[current].avatar;
      quoteEl.classList.remove('fading');
      Array.prototype.forEach.call(dotsEl.children, function(d, idx){
        d.className = idx === current ? 'active' : '';
      });
    }, 300);
  }

  function next(){ show((current + 1) % testimonials.length); }
  function resetTimer(){ clearInterval(timer); timer = setInterval(next, 4500); }

  resetTimer();
})();

(function(){
  function revealAllTimelineRows(){
    document.querySelectorAll('.tl-row').forEach(function(r){ r.classList.add('in-view'); });
  }

  var rows = document.querySelectorAll('.tl-row');
  if(rows.length){
    if(!('IntersectionObserver' in window)){
      revealAllTimelineRows();
    } else {
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -40px 0px' });
      rows.forEach(function(row){ observer.observe(row); });

      // Safety net: if the observer never fires for any reason (theme editor
      // preview iframe quirks, timing, etc.), force-reveal everything after a
      // short delay so content can never get stuck permanently invisible.
      setTimeout(revealAllTimelineRows, 1500);
    }
  }

  // Shopify's theme editor re-renders a section's HTML via AJAX whenever a
  // setting/block is edited, without re-running page-load JS. Re-apply
  // visibility immediately whenever that happens so rows never sit hidden
  // in the editor preview while you're actively editing them.
  document.addEventListener('shopify:section:load', revealAllTimelineRows);
})();

(function(){
  // Image slider: slides a flex track horizontally via CSS transform +
  // transition, so images actually slide into place rather than
  // instantly swapping. No JSON parsing — slides are plain pre-rendered HTML.
  document.querySelectorAll('.offer-card2').forEach(function(card){
    var slider = card.querySelector('.os-slider');
    if(!slider) return;
    var track = slider.querySelector('.os-slide-track');
    var slideEls = slider.querySelectorAll('.os-slide');
    var thumbWrap = card.querySelector('.os-thumbs');
    var thumbs = thumbWrap ? thumbWrap.querySelectorAll('button') : [];
    var idx = 0;

    function setActive(i){
      idx = (i + slideEls.length) % slideEls.length;
      if(track) track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      thumbs.forEach(function(t, ti){ t.classList.toggle('active', ti === idx); });
    }

    thumbs.forEach(function(t, ti){ t.addEventListener('click', function(){ setActive(ti); }); });

    var prev = slider.querySelector('.os-arrow.prev');
    var next = slider.querySelector('.os-arrow.next');
    if(prev) prev.addEventListener('click', function(){ setActive(idx - 1); });
    if(next) next.addEventListener('click', function(){ setActive(idx + 1); });
  });

  // Quantity steppers on offer cards — also updates the real hidden cart
  // quantity input (data-unit-quantity on the form = units per 1 "pack")
  document.querySelectorAll('.oc-qty').forEach(function(qty){
    var valEl = qty.querySelector('.val');
    var buttons = qty.querySelectorAll('button');
    var card = qty.closest('.offer-card2');
    var form = card ? card.querySelector('form[data-unit-quantity]') : null;
    var hiddenQty = form ? form.querySelector('.oc-qty-input') : null;
    var unit = form ? (parseInt(form.getAttribute('data-unit-quantity'), 10) || 1) : 1;
    var n = 1;
    function sync(){
      valEl.textContent = n;
      if (hiddenQty) hiddenQty.value = n * unit;
    }
    buttons[0].addEventListener('click', function(){ n = Math.max(1, n - 1); sync(); });
    buttons[1].addEventListener('click', function(){ n = n + 1; sync(); });
  });
})();

(function(){
  var filterBtns = document.querySelectorAll('#revFilters button');
  var cards = document.querySelectorAll('#revList .rev-card');
  if(!filterBtns.length) return;
  filterBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      filterBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      var cat = btn.getAttribute('data-cat');
      cards.forEach(function(card){
        var cardCats = (card.getAttribute('data-cat') || '').split(' ');
        var show = cat === 'all' || cardCats.indexOf(cat) !== -1;
        card.classList.toggle('visible', show);
      });
    });
  });
})();

(function(){
  var timers = document.querySelectorAll('.js-countdown');
  if(!timers.length) return;

  function pad(n){ return String(n).padStart(2, '0'); }

  function tick(el){
    var targetStr = el.getAttribute('data-target');
    var target = new Date(targetStr.replace(' ', 'T')).getTime();
    var now = new Date().getTime();
    var diff = target - now;

    var dEl = el.querySelector('[data-unit="d"]');
    var hEl = el.querySelector('[data-unit="h"]');
    var mEl = el.querySelector('[data-unit="m"]');
    var sEl = el.querySelector('[data-unit="s"]');

    if (diff <= 0) {
      if(dEl) dEl.textContent = '00';
      if(hEl) hEl.textContent = '00';
      if(mEl) mEl.textContent = '00';
      if(sEl) sEl.textContent = '00';
      return;
    }

    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    if(dEl) dEl.textContent = pad(days);
    if(hEl) hEl.textContent = pad(hours);
    if(mEl) mEl.textContent = pad(minutes);
    if(sEl) sEl.textContent = pad(seconds);
  }

  timers.forEach(function(el){ tick(el); });
  setInterval(function(){
    timers.forEach(function(el){ tick(el); });
  }, 1000);
})();
}
